const scrollPositions: Record<string, number> = {
  seriesIndex: 0,
};

export default scrollPositions;
